import * as React from 'react';
import CrumbType from 'src/react/components/breadcrumbs/types/Crumb';
import Crumb from 'src/react/components/breadcrumbs/components/Crumb';
import { FC } from 'react';

type CrumbsProps = {
  crumbs: CrumbType[],
};

const Crumbs: FC<CrumbsProps> = ({ crumbs }) => (
  <ol className="breadcrumb">
    {crumbs.map((crumb, i) => (
      <Crumb
        key={crumb.id}
        id={crumb.id}
        url={crumb.url}
        title={crumb.title}
        isActive={i === crumbs.length - 1}
      />
    ))}
  </ol>
);

export default Crumbs;
